module.exports = __webpack_public_path__ + "img/logo.3ff327c0.svg";